export const isDesktop = window.screen.width > 800;
